import { createFileRoute } from "@tanstack/react-router";
import { auth } from "@/content";
import { TokenLinkPage } from "@/components/auth/token-link";

/** Setting a new password from a reset link. Shared screen; see `TokenLinkPage`. */
export const Route = createFileRoute("/_auth/_anonymous/reset-password")({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  return (
    <TokenLinkPage
      purpose="reset"
      title={auth.resetTitle}
      lead={auth.resetLead}
      submitLabel={auth.resetSubmit}
      expiredTitle={auth.linkExpiredTitle}
      expiredLead={auth.linkExpiredLead}
      usedLead={auth.linkUsedLead}
    />
  );
}
